<div>
    <p-toast></p-toast>
    <p-confirmDialog #cd [style]="{'max-width': '60vw', 'width': '60vw'}" styleClass="custom-confirm-dialog">
        <ng-template pTemplate="headless" let-message>
            <div class="flex flex-col items-center p-8 bg-white rounded-2xl relative">
                <div class="absolute -top-10 w-24 h-24 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center shadow-lg animate-bounce-in">
                    <i class="pi pi-exclamation-triangle text-5xl text-white"></i>
                </div>
                <div class="mt-16 text-center w-full">
                    <h3 class="text-2xl font-bold text-gray-900 mb-3">
                        {{ message.header }}
                    </h3>
                    <p class="text-base text-gray-600 leading-relaxed px-4 mb-6">
                        {{ message.message }}
                    </p>
                    <div class="flex items-center justify-center gap-3 mt-6">
                        <button 
                            pButton 
                            type="button"
                            [label]="message.acceptLabel || 'Yes, Continue'" 
                            (click)="message.accept && message.accept()" 
                            class="px-8 py-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl hover:from-orange-600 hover:to-orange-700 transition-all duration-200 transform hover:-translate-y-0.5">
                        </button>
                        <button 
                            *ngIf="message.rejectVisible !== false"
                            pButton
                            type="button"
                            [label]="message.rejectLabel || 'Cancel'"
                            (click)="message.reject && message.reject()"
                            class="px-8 py-3 bg-white text-gray-700 font-semibold rounded-lg border-2 border-gray-300 hover:bg-gray-50 hover:border-gray-400 transition-all duration-200">
                        </button>
                    </div>
                </div>
            </div>
        </ng-template>
    </p-confirmDialog>
    
    <app-tool-bar [title]="'Registration'" [iconName]="'pi-address-book'" [isSearch]="true" [isDateFilter]="true"
        [selectedProducts]="selectedProducts" [isBulkAction]="true" [bulkActionItems]="bulkActionItems"
        [filtersOptions]="filtersOptions" [isAdd]="true" (handleAdd)="fnHandleAddd()" (search)="handleSearch($event)"
        [exportItems]="exportItems" [isExport]="true" (dateFilter)="handleDateFilter($event)"
        (resetDateFilter)="handleResetFilters()" (ExportData)="export($event)"></app-tool-bar>
</div>


<div class="p-4 overflow-auto h-[85vh]">
    <p-table [value]="leadsData" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true"
        (onLazyLoad)="loadCustomers($event)" [(selection)]="selectedProducts" [loading]="loading"
        [rowsPerPageOptions]="totalRecords > 10 ? [10, 20, 50] : undefined" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
        <ng-template pTemplate="header">
            <tr style="height: 60px;">
                <th style="width: 4rem; border-top-left-radius: 10px; padding: 1rem;"><p-tableHeaderCheckbox /></th>
                <th *ngFor="let col of displayedColumns" [pSortableColumn]="col.sortable ? col.field : ''" style="padding: 1rem; font-weight: 600; font-size: 0.95rem;">
                    {{ col.header }}
                    <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-customer let-i="rowIndex" let-rowData>
            <tr style="height: 65px;">
                <td style="padding: 1rem;">
                    <p-tableCheckbox [value]="customer" />
                </td>
                <td *ngFor="let col of displayedColumns" style="padding: 1rem; vertical-align: middle;">
                    <ng-container [ngSwitch]="col.type">
                        <!-- Handle Nested Object (Lead Owner) -->
                        <ng-container *ngSwitchCase="'nested'">
                            {{ (rowData.user?.prefix ?? 'N/A') +
                            (rowData.user?.fname ? ' ' + rowData.user.fname : '') +
                            (rowData.user?.lname ? ' ' + rowData.user.lname : '') }}
                        </ng-container>

                        <ng-container *ngSwitchCase="'registration_id'">
                            <div style="min-width: 100px;">
                                <a (click)="openRegistrationProfile(rowData)" class="text-blue-700 underline cursor-pointer">
                                    {{ rowData.registration?.registration_id || 'N/A' }}
                                </a>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'course'">
                            {{ rowData.registration?.course?.name || 'N/A' }}
                        </ng-container>

                        <ng-container *ngSwitchCase="'assigned_to'">
                            {{ (rowData.assignedUser?.prefix ?? 'N/A') +
                            (rowData.assignedUser?.fname ? ' ' + rowData.assignedUser.fname : '') +
                            (rowData.assignedUser?.lname ? ' ' + rowData.assignedUser.lname : '') }}
                        </ng-container>

                        <ng-container *ngSwitchCase="'contact_name'">
                            {{ getFullContactName(rowData) }}
                        </ng-container>

                        <ng-container *ngSwitchCase="'status'">
                            <div class="flex items-center gap-1 rounded-full px-5 py-[1px] w-fit min-w-[120px] font-medium"
                                [style.borderWidth]="'2px'" [style.borderStyle]="'solid'"
                                [style.borderColor]="getStatusColor(rowData.registration?.status)"
                                [style.color]="getStatusColor(rowData.registration?.status)" style="font-weight: 500;">
                                <div style="margin-top: 2px;">
                                    <svg width="25px" height="25px" viewBox="0 0 32 32"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <g [attr.stroke]="getStatusColor(rowData.registration?.status)" stroke-width="3"
                                            fill="none" stroke-linecap="round" stroke-linejoin="round">
                                            <path
                                                d="M12,13 C9.23857625,13 7,10.7614237 7,8 C7,5.23857625 9.23857625,3 12,3 C14.7614237,3 17,5.23857625 17,8 C17,10.7614237 14.7614237,13 12,13 Z M11.0150512,21 C9.04777237,21 6.37608863,21 3,21 C3.79921286,17.89195 6.4614209,16.2328962 10.9866241,16.0228387">
                                            </path>
                                            <polyline points="21.0037832 16.5969533 17 21 14.4906972 18.5114193">
                                            </polyline>
                                        </g>
                                    </svg>
                                </div>
                                {{
                                rowData.registration?.status || 'N/A'
                                }}
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'source'">
                            <img [src]="getLeadSourceImg(rowData[col.field])"
                                class="h-[33px] w-[30px] object-contain"
                                [pTooltip]="rowData[col.field]"
                                tooltipPosition="top" />
                        </ng-container>

                        <ng-container *ngSwitchCase="'createdAt'">
                            {{
                            rowData?.registration?.createdAt | date: 'dd/MM/yyyy'
                            }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'student_profile'">
                            <span class="flex items-center gap-1 ml-3">
                                <i [ngClass]="rowData?.is_student_profile? 'pi pi-check-circle text-green-600': 'pi pi-times-circle text-red-600'">
                                </i>

                                <span [ngClass]="rowData?.is_student_profile ? 'text-green-700' : 'text-red-700'">
                                    {{ rowData?.is_student_profile ? 'Yes' : 'No' }}
                                </span>
                            </span>
                        </ng-container>



                        <ng-container *ngSwitchCase="'date'">
                            {{
                            rowData[col.field] | date: 'dd/MM/yyyy'
                            }}
                        </ng-container>

                        <ng-container *ngSwitchCase="'communicate'">
                            <div class="flex gap-3 font-semibold ml-3">
                                <i class="pi pi-phone"
                                    style="color: #F0950C; font-weight: 600; font-size: 1rem; cursor: pointer;"
                                    (click)="handleCallLead(rowData)"></i>
                                <i class="pi pi-whatsapp" (click)="handleWhatsappLead(rowData)"
                                    style="color: #1FAF38; font-weight: 600; font-size: 1rem; cursor: pointer;"></i>
                                <i class="pi pi-envelope" (click)="handleEmailLead(rowData)"
                                    style="font-size: 1rem; color: #0960BD; font-weight: 600; cursor: pointer;"></i>
                            </div>
                        </ng-container>

                        <ng-container *ngSwitchCase="'dynamic_fields'">
                            {{
                            rowData?.['dynamic_fields']?.[col.field] || 'N/A'
                            }}
                        </ng-container>

                        <!-- Handle Boolean -->
                        <ng-container *ngSwitchCase="'number'">
                            {{
                            rowData[col.field] || 0
                            }}
                        </ng-container>

                        <ng-container *ngSwitchCase="'placeholder'">
                            {{
                            rowData[col.field] || 'N/A'
                            }}
                        </ng-container>

                        <!-- Handle Actions -->
                        <ng-container *ngSwitchCase="'actions'">
                            <div *ngIf="!loading" (click)="setLeadEditData(rowData)" class="flex justify-center">
                                <p-menu [tabindex]="undefined" #menu [model]="leadActionItems" [popup]="true"
                                    appendTo="body"></p-menu>
                                <button 
                                    (click)="menu.toggle($event)"
                                    class="inline-flex items-center justify-center w-9 h-9 rounded-full bg-gray-100 hover:bg-blue-50 hover:shadow-md cursor-pointer transition-all duration-200 ease-in-out">
                                    <i class="pi pi-ellipsis-h text-lg text-gray-700 hover:text-blue-600"></i>
                                </button>
                            </div>
                        </ng-container>

                        <!-- Default Case (Normal Field) -->
                        <ng-container *ngSwitchDefault>
                            {{ rowData[col.field] }}
                        </ng-container>
                    </ng-container>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="loading">
            <tr>
                <td colspan="3" class="text-center">
                    <p-progressSpinner></p-progressSpinner>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="displayedColumns.length + 1" class="no-data">
                    <p>No records found</p>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>


<p-dialog [modal]="true" [(visible)]="isOpenAddDialog" [breakpoints]="{ '1199px': '80vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '70vw' }" [draggable]="false" [resizable]="false">
    <app-add-lead [allCourses]="allCourses" [isRegsiteration]="true" (closeDialog)="isOpenAddDialog = false"
        [formAction]="'Add'" [allLeadFeilds]="allLeadFeilds" [users]="users"
        (reload)="reloadDataTable()"></app-add-lead>
</p-dialog>


<p-dialog [modal]="true" [(visible)]="isBulkUpdate" [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">
    <app-bulk-update [title]="'Registrations'" [selectedProducts]="selectedProducts" [users]="users"
        [isRegistration]="true" [courses]="allCourses" (reload)="reloadDataTable()"
        (closeDialog)="isBulkUpdate = false"></app-bulk-update>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="isUploadDocument" [breakpoints]="{ '1199px': '80vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '60vw' }" [draggable]="false" [resizable]="false">
    <ng-container *ngIf="isUploadDocument">
        <app-upload-documents [editLeadData]="editLeadData" (reload)="reloadDataTable()"
            (closeDialog)="isUploadDocument = false"></app-upload-documents>
    </ng-container>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="isBulkSendEmail" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <app-lead-email (closeDialog)="isBulkSendEmail = false" [selectedProducts]="selectedProducts" [isBulk]="true"
        (removeSelectedProducts)="removeSelectedProducts()"></app-lead-email>
</p-dialog>



<p-dialog [modal]="true" [(visible)]="isDeleteLead" [breakpoints]="{ '1199px': '50vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">
    <app-delete-registration (closeDialog)="isDeleteLead = false" [editLeadData]="editLeadData"
        (reload)="reloadDataTable()"></app-delete-registration>
</p-dialog>


<p-dialog [modal]="true" [(visible)]="isBulkDeleteLead" [breakpoints]="{ '1199px': '50vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '40vw' }" [draggable]="false" [resizable]="false">
    <ng-container *ngIf="isBulkDeleteLead">
        <app-delete-bulk-registration (closeDialog)="isBulkDeleteLead = false" [selectedProducts]="selectedProducts"
            (reload)="reloadDataTable()"></app-delete-bulk-registration>
    </ng-container>
</p-dialog>


<p-dialog [modal]="true" [(visible)]="isEmailLead" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
    <app-lead-email (closeDialog)="isEmailLead = false" [communicationData]="leadDetails"></app-lead-email>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="isCallLead" [breakpoints]="{ '1199px': '50vw', '575px': '90vw', }"
    closable="false" [style]="{ width: '35vw' }" [draggable]="false" [resizable]="false">
    <app-lead-call (closeDialog)="isCallLead = false" [communicationData]="leadDetails"></app-lead-call>
</p-dialog>



<p-dialog [modal]="true" [(visible)]="isMoveToApplication" [breakpoints]="{ '1199px': '50vw', '575px': '90vw', }"
    closable="false" [style]="{ width: '35vw' }" [draggable]="false" [resizable]="false">
    <app-move-to-application (closeDialog)="isMoveToApplication = false" [editLeadData]="editLeadData"
        (reload)="reloadDataTable()"></app-move-to-application>
</p-dialog>



<p-dialog [modal]="true" [(visible)]="isCreateStudentProfile" [breakpoints]="{ '1199px': '50vw', '575px': '90vw', }"
    closable="false" [style]="{ width: '35vw' }" [draggable]="false" [resizable]="false">
    <app-create-student-profile (closeDialog)="isCreateStudentProfile = false" [editLeadData]="editLeadData"
        (reload)="reloadDataTable()"></app-create-student-profile>
</p-dialog>



<p-dialog [modal]="true" [(visible)]="isBulkMoveToApplication" [breakpoints]="{ '1199px': '50vw', '575px': '90vw', }"
    closable="false" [style]="{ width: '35vw' }" [draggable]="false" [resizable]="false">
    <app-bulk-move-to-application (closeDialog)="isBulkMoveToApplication = false" [selectedProducts]="selectedProducts"
        (reload)="reloadDataTable()"></app-bulk-move-to-application>
</p-dialog>



<p-dialog [modal]="true" *ngIf="isWhatsappLead" [(visible)]="isWhatsappLead"
    [breakpoints]="{ '1199px': '70vw', '575px': '90vw', }" closable="false" [style]="{ width: '60vw' }"
    [draggable]="false" [resizable]="false">
    <app-whatsapp-communication (closeDialog)="isWhatsappLead = false"
        [communicationData]="leadDetails"></app-whatsapp-communication>
</p-dialog>